exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".settings-item-section .item-view-branch-dd .multiSelect .checkboxLayer {\n  width: 91%;\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n\n.settings-item-section .item-view-branch-dd .multiSelect .show {\n  display: block !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/item/item.scss
// module id = 1040
// module chunks = 1